import script from "./email-items.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-items.vue?vue&type=script&setup=true&lang=ts"

import "./email-items.vue?vue&type=style&index=0&id=301a3ec0&lang=scss"

const __exports__ = script;

export default __exports__